<script lang="ts">
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	// import '@splidejs/svelte-splide/css/core';
	import '@splidejs/svelte-splide/css';
	import { activeCity } from './CityfloCheckRoute/store';
	import { isMobile } from '~/utils/store';
	// import { afterUpdate } from "svelte";

	import RouteExplorationCard from '~/components/atoms/RouteExplorationCard.svelte';

	export let routes: RouteExplorationCard[];

	let id: string;

	$: id = `route-cards-${$activeCity}`;

	// afterUpdate(() => {
	// 	new Slider(id);
	// })
</script>

<div data-id={id} class="pb-8 md:pb-10">
	<!-- <ul class="slider-track grid grid-rows-1 overflow-x-auto snap-mandatory snap-x hide-scroll-bar gap-8 pb-10 grid-flow-col-dense" style={`grid-template-columns: repeat(${routes.length}, ${$isMobile ? '300' : '340' }px)`}>
		{#each routes as route}
			<li class="track snap-center snap-always rounded-2xl shadow-md">
				<RouteExplorationCard data={route} />
			</li>
		{/each}
	</ul>
	<div class="slider-dots flex flex-wrap justify-start select-none"></div> -->
	{#if $isMobile !== undefined}
		<Splide
			options={{
				arrows: false,
				fixedWidth: $isMobile ? '300px' : '280px',
				focus: 'center',
				gap: $isMobile ? '1em' : '2em',
				pagination: false,
				// rewindByDrag: true,
				type: 'slide',
				width: '100%',
				trimSpace: !$isMobile,
			}}
		>
			{#each routes as route}
				<SplideSlide class="rounded-2xl !my-2" aria-roledescription="slide">
					<RouteExplorationCard small data={route} page="home" />
				</SplideSlide>
			{/each}
		</Splide>
	{/if}
</div>

<!-- <style>
	ul {
		grid-template-columns: repeat(var(--busesLength), 100%);
	}

	@media (min-width: 599px) and (max-width: 1023px) {
		ul {
			grid-template-columns: repeat(var(--busesLength), 60%);
		}
	}

	/* @media only screen and (min-width: 768px) {
		ul {
			grid-template-columns: repeat(var(--busesLength), 400px);
		}
	} */

	@media only screen and (min-width: 1024px) {
		ul {
			grid-template-columns: repeat(var(--busesLength), 29%);
		}
	}
</style> -->
